<template>
  <div>
    <cancel-heading is-centered>Schedule Today</cancel-heading>
    <cancel-content is-centered>
      Schedule your Free 30-minute 1-on-1 coaching call by
      <a
        href="https://api.leadconnectorhq.com/widget/bookings/forefront-crm-onboarding"
        target="_blank"
      >clicking here</a>
    </cancel-content>
  </div>
</template>

<script>
import CancelContent from "./components/CancelContent.vue";
import CancelIcon from "./components/CancelIcon.vue";
import CancelHeading from "./components/CancelHeading.vue";

export default {
  name: "OfferExpertConfirmation",
  components: {CancelHeading, CancelIcon, CancelContent}
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.cancel_schedule {
  display: block;
  margin-top: 8px;
  padding: 6px 10px;
  border: 1px solid $secondary;

  &:hover {
    background-color: $secondary;
    color: $white;
  }
}
</style>
